export const popperZIndex = 12
export const popperSmallZIndex = 12
export const toastZIndex = 100019
export const screenBlockerZIndex = 100002
export const busyCursorZIndex = 100001
export const ITEM_WIDTH = 220
// can be used to specify max batch size for firestore batch update 
export const MAX_CHUNK_SIZE = 400
export const DEFAULT_LANGUAGE = 'en-US'
// nats constants buckets , servers
export const LOCAL_AI_REF_IMG = 'localAIRefImg' // use it for refernce image only
export const LOCAL_AI_ASSET_IMG = 'localAIAssetImg' // use this bucket for captured image
export const LOCAL_NATS_SERVER = ''
export const LOCAL_AI_PROTOCAL = 'ws'
export const CUSOTM_LOCAL_AI_ERROR_CODES = Object.freeze({
  CONNECTION_STRING_NOT_FOUND: '404_LOCAL_AI_CONNECTION_ERROR'
})
export const MAX_LOCAL_AI_IMG_UPLOAD = 3
// 'ws://localhost:8080'
// 'ws://10.221.64.129:443'
export const subjectName = 'imagesSubject'
export const streamName = 'localAI'

export const defaultSelect = '--Select--'
export const defaultSelectForCE = '-Select BAU or Project-'
export const defaultForAccountLevel = ''
export const notApplicable = 'Not Applicable'
export const jobStatus = { 
  pending: 'Pending',
  assigned: 'Assigned', 
  inProgress: 'In Process', 
  transmitted: 'Transmitted', 
  cancel: 'Cancelled',
  readyToTransmit: 'Ready To Transmit',
  deleted: 'Deleted',
  completed: 'Completed'
}

export const transmittalStatus = { 
  pending: 'pending',
  failed: 'failed',
  uploaded: 'uploaded', 
  published: 'published',
  processed: 'processed',
  cancelled: 'cancelled',
  unapproved: 'unapproved'
}

export const activityStatus = { 
  pending: 'pending',
  assigned: 'assigned', 
  inProgress: 'In Progress', 
  transmitted: 'transmitted', 
  cancel: 'cancelled',
  deleted: 'deleted',
  completed: 'completed',
  failed: 'failed',
  submitted: 'submitted'
}

export const imageStatus = { 
  submitted: 'Image Submitted',
  acknowledged: 'Image Acknowledged',
  pendingQC: 'Image Pending QC',
  completedQC: 'QC completed',
  uploadPending: 'Pending SKP/ONeil upload',
  uploaded: 'Smart Catalog Completed',
  pending: 'Pending',
  completed: 'Completed'
}

export const boxStatus = { 
  dataEntryInProcess: 'Data Entry In Process', 
  dataEntryComplete: 'Data Entry Complete', 
  readyForVerification: 'Ready For Verification', 
  verificationInProcess: 'Verification In Process', 
  readyForQc: 'Ready For Quality Check', 
  qcInProcess: 'Quality Check In Process', 
  requiresReKey: 'Requires Rekey', 
  approved: 'Ready To Transmit', 
  transmitted: 'Transmitted', 
  exception: 'Exception' 
}
export const templateTypes = {
  newFile: 'skpStandardNewFile',
  newBox: 'skpStandardNewBox',
  maintenanceFile: 'skpStandardMaintenanceFile',
  maintenanceBox: 'skpStandardMaintenanceBox',
  oneilNewTransmittal: 'oneilStandardNewBoxTransmittal',
  oneilMaintenanceTransmittal: 'oneilStandardMaintenanceBoxTransmittal',
  skpNewTransmittal: 'skpStandardNewBoxTransmittal',
  skpMaintenanceTransmittal: 'skpStandardMaintenanceBoxTransmittal'
}
export const boxTransmissionStatus = { 
  pending: 'Pending',
  inProcess: 'In Process', 
  transmitted: 'Transmitted'
}
export const fileStatus = {
  keyed: 'Keyed',
  inProgress: 'In Progress',
  verified: 'Verified'
}
export const approved = 'Approved'
export const react = 'React'

export const userId1 = '0100002'
export const firstOption = '1'
export const secondOption = '2'
export const defaultChipLabel = '10'

export const accountLevel1 = 'accountLevel1'
export const accountLevel2 = 'accountLevel2'
export const accountLevel3 = 'accountLevel3'
export const templateType = 'templateType'
export const templateName = 'templateName'
export const wmsCode = 'wmsCode'

export const NoApprove = 'NoApprove'
export const jobStatus1 = 'jobStatus'
export const deType = 'deType'
export const Approved = 'Approved'
export const readyForEntry = 'Ready for Entry'
export const dateCreatedFrom = 'Date Created From'
export const dateCreatedTo = 'Date Created To'
export const actionTs = 'actionTs'
export const country = 'country'
export const dataEntryType = 'dataEntryType'
export const keystrokeType = 'keystroke'
export const authWrongPassword = 'auth/wrong-password'
export const authEmailAlreadyInUse = 'auth/email-already-in-use'
export const pauseMetrics = 'pause'
export const pauseCount = 'pause_count'
export const retransmitAction = 'retransmit'

export const activeJobStatus = ['Assigned', 'In Process', 'Pending', 'Ready To Transmit']